import React, { useEffect, useState } from "react";
import { icons } from "../../assets/icons";
import { assetGifCharacter } from "../../assets/charactergifs";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";



const selectCharacter = localStorage.getItem("character") ?? "1"
const namesCharactes = {
	"1": "andatti",
	"2": "cel",
	"3": "premia",
	"4": "spin",
}

export const ModalResultFinalTopic = ({
	title = "",
	subTitle = "",
	points = { total: 0, won: 0 },
	buttonText = "",
	statusModal = 0,
	actionButton = () => { },
}) => {
	const [imgStatus, setImgStatus] = useState("")
	useEffect(() => {
		const name = namesCharactes[selectCharacter]
		if (!name) {
			return
		}
		const { festejo, pena } = assetGifCharacter["andatti"]
		if (statusModal === 2) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardFine)
			setImgStatus(festejo)
		} else {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardMalHecho)
			setImgStatus(pena)
		}
	}, [statusModal])
	return (
		<div className="fixed z-30 bg-[#00000074] w-full h-full flex justify-center items-center">
			<div
				className={`w-[272px] h-[312px] md:w-[464px] md:h-[552px] border-white overflow-hidden border-[4px] bg-cover bg-no-repeat bg-center rounded-3xl relative ${statusModal === 2 ? "bg-backfeedbackYellow" : "bg-backfeedbackRed"
					}`}
			>
				<div className="absolute z-10 bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 h-[222px] w-[200px] md:w-[320px] md:h-[396px] rounded-t-full rounded-b-[900px]  bg-gradient-to-b from-[#FFB237] to-[#F48401]"></div>
				<div className="absolute pt-4 pb-8 md:pt-4 md:pb-16 z-20 h-full w-full">
					<div className="h-full w-full">
						<div className=" h-[24px] md:h-[44px] flex items-center px-4 md:px-6">
							<div className="w-[44px] h-[24px] md:h-[40px] md:w-[80px]">
								<img className="h-full w-full object-contain" src={icons.logooxxo} alt="logo" />
							</div>
						</div>
						<div className="h-[32px] md:h-[64px] flex justify-center items-center">
							<p className="text-white text-[20px] md:text-[40px] font-extrabold text-center">{title}</p>
						</div>
						<div className="h-[calc(100%-157px)] md:h-[calc(100%-273px)] px-12 md:px-24">
							<div className="relative h-full w-full">
								<div className="absolute z-10 h-full md:h-[110%] w-full -top-5 md:-top-12">
									<div className="h-full w-full flex justify-center items-center">
										{/* <img className="h-full w-full object-contain" src={imgs.personGame} alt="game" /> */}
										<img className="h-full w-full object-contain" src={imgStatus} alt="game" />
									</div>
								</div>
								<div className="absolute z-20 bottom-0 bg-red_primary border-[1px] border-yellow_primary w-full h-[38px] md:h-[65px] rounded-lg flex justify-center items-center px-2">
									<p className="text-white text-[8px] md:text-[14px] text-center">{subTitle}</p>
								</div>
							</div>
						</div>
						<div className="h-[56px] md:h-[120px] ">
							<div className="h-full w-full flex flex-col items-center justify-start pt-1 md:pt-4">
								<p className="text-white text-[12px] md:text-[16px]">Puntos</p>
								<p className="text-white text-[14px] md:text-[20px]">
									{points.won}/{points.total}
								</p>
							</div>
						</div>
						<div className="h-[45px]">
							<div className="h-full w-full px-14 md:px-24">
								<div onClick={() => {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
									actionButton()
								}} className="boxShadowButtons bg-yellow_primary h-full w-full rounded-xl flex justify-center items-center">
									<p className="text-white text-[20px] font-semibold">{buttonText}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
